<template>
  <div v-if="ticket">
    <v-layout row wrap>
      <v-flex xs12 sm6 class="form-control px-1 pb-2" :class="{ 'has-error': errors.has('group') }">
        <div class="caption mb-1 mt-2">Group</div>
        <v-autocomplete
          :value="ticket.group"
          :items="agentGroup"
          item-text="groupname"
          item-value="id"
          name="group"
          outline
          class="default-input"
          placeholder="Select Group"
          hide-details
          single-line
          @input="onChangeGroup"
        ></v-autocomplete>
        <p v-if="errors.has('group')" class="text-error">
          {{ errors.first('group') }}
        </p>
      </v-flex>
      <v-flex v-if="ticket.group" xs12 sm6 class="form-control px-1 pb-2">
        <div class="caption mb-1 mt-2">Subgroup</div>
        <v-layout>
          <v-autocomplete
            :key="`subgroup-${autocompleteTimestamp}`"
            :value="ticket.subgroup"
            :items="filterSubGroup"
            item-text="subgroupname"
            item-value="id"
            outline
            single-line
            class="default-input"
            placeholder="Select Subgroup"
            hide-details
            clearable
            @input="updateInput('subgroup', $event)"
          ></v-autocomplete>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm6>
        <div class="caption mb-1 mt-2">Priority</div>
        <v-select
          single-line
          :value="ticket.priority"
          :items="priorityOptions"
          item-text="label"
          item-value="value"
          :return-object="false"
          outline
          hide-details
          class="default-input"
          placeholder="Select Priority"
          @input="updateInput('priority', $event)"
        >
        </v-select>
      </v-flex>
      <v-flex xs12>
        <div class="caption mb-1 mt-2">Tags</div>
        <template v-if="selectedBot.theme == 'toa'">
          <TagManagement
            :value="ticket.tags"
            :items="ticketTagsFull"
            :filter="tagsfilter"
            @onDirty="
              () => {
                isDirtyTagManagement = true
              }
            "
            @input="updateInput('tags', $event)"
          />
        </template>
        <TicketTags
          v-else
          :tags="ticket.tags"
          :items="ticketTagsFull"
          @onChangeTag="handleChangeTicketTags"
        />
      </v-flex>
    </v-layout>
    <v-divider class="my-4"></v-divider>
    <div>Due Date</div>
    <v-layout wrap>
      <v-flex xs4 class="px-1 form-control">
        <div class="caption">Day</div>
        <input
          :value="ticket.day"
          placeholder="Days"
          type="text"
          @input="updateInput('day', numberOnly($event, 'day'))"
        />
      </v-flex>
      <v-flex xs4 class="px-1 form-control">
        <div class="caption">Hour</div>
        <input
          :value="ticket.hour"
          placeholder="Hour"
          type="text"
          @input="updateInput('hour', numberOnly($event, 'hour'))"
        />
      </v-flex>
      <v-flex xs4 class="px-1 form-control" :class="{ 'has-error': errors.has('Minute') }">
        <div class="caption">Minute</div>
        <input
          v-validate="'max_value:59'"
          :value="ticket.minute"
          name="Minute"
          placeholder="Minute"
          type="text"
          @input="updateInput('minute', numberOnly($event, 'minute'))"
        />
        <p v-if="errors.has('Minute')" class="text-error">
          {{ errors.first('Minute') }}
        </p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import TagManagement from '@/components/view/ticket/TagManagement'
import TicketTags from './../TicketTags'
import { mapGetters } from 'vuex'
import { priorityOptions } from '@/constants/ticket3/ticketConstant'
import moment from 'moment'
export default {
  components: {
    TagManagement,
    TicketTags
  },
  props: ['ticket', 'loading'],
  data() {
    return {
      isDirtyTagManagement: false,
      priorityOptions: priorityOptions,
      filterSubGroup: [],
      autocompleteTimestamp: moment().valueOf()
    }
  },
  computed: {
    ...mapGetters({
      ticketTagsFull: 'ticketTagsFull',
      selectedBot: 'selectedBot',
      agentGroup: 'getAgentGroup',
      agentSubGroup: 'getAgentSubgroup'
    })
  },
  async mounted() {
    this.handleFilterSubGroup()
    await this.$nextTick()
    this.autocompleteTimestamp = moment().valueOf()
  },
  methods: {
    tagsfilter(item, queryText, itemText) {
      if (item.header) return false

      const hasValue = (val) => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    },
    updateInput(key, value) {
      this.$emit('updateInput', key, value)
    },
    handleChangeTicketTags(tags) {
      this.updateInput('tags', tags)
    },
    async onChangeGroup(value) {
      this.updateInput('group', value)
      this.updateInput('subgroup', null)
      this.updateInput('assignedTo', null)
      this.handleFilterSubGroup()

      await this.$nextTick()
      this.autocompleteTimestamp = moment().valueOf()
    },
    handleFilterSubGroup() {
      this.filterSubGroup = this.agentSubGroup.filter((item) => {
        return item.admingroupid === this.ticket.group
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/Ticket/ManageIntentTicketGroup.vue